fragment customerSettingsInfo on CustomerSettings {
  id
  workBlockLayout
}
